import io from 'socket.io-client';
import { DIGITAL_SIGN_SOCKET_BASEURL } from './digiSocketConfig';

let digiSocketUrl = null;
let currentUrl = null;

const digiSocket = () => {
  const newUrl = DIGITAL_SIGN_SOCKET_BASEURL();

  // Create digi socket first time OR recreate if URL changed
  if (!digiSocketUrl || newUrl !== currentUrl) {
    if (digiSocketUrl) {
      digiSocketUrl.disconnect(); // clean up old connection
    }

    currentUrl = newUrl;
    digiSocketUrl = io(newUrl, {});
  }

  return digiSocketUrl;
};

export default digiSocket;